import { FormControl } from '@angular/forms';
import { PaymentType } from '@domgen/dgx-fe-common';
import { PaymentMethodFormField } from './payment-method-form-field.enum';

export interface PaymentMethodForm {
  [PaymentMethodFormField.PaymentType]: FormControl<PaymentType>;
}
